jQuery(document).ready(function($) {
    
	$('.post-grid__sidebar-btn').click(function(e) {
		e.preventDefault();
		$('.post-grid__sidebar').slideToggle();

		if($(this).hasClass('active')) {
			$(this).text('Show Sidebar').removeClass('active');
		} else {
			$(this).text('Hide Sidebar').addClass('active');
		}
	});
 
});
